/**
 * Landing contact dispatcher.
 *
 * Sends form data to the Orkestria backend (POST /contact), which uses Resend
 * to deliver the email to criskop.dev@gmail.com — same infrastructure as
 * electronic invoices.
 */

export type ContactPayload = {
  subject: "demo" | "enterprise" | "access";
  name: string;
  email: string;
  phone?: string;
  company?: string;
  locations?: string;
  message?: string;
};

export const CONTACT_TO = "criskop.dev@gmail.com";

const SUBJECT_LABEL: Record<ContactPayload["subject"], string> = {
  demo: "Solicitud de demo · Orkestria",
  enterprise: "Contacto Enterprise · Orkestria",
  access: "Solicitud de acceso · Orkestria",
};

function getApiBase(): string {
  // NEXT_PUBLIC_API_URL is e.g. "http://localhost:4600/api" — reuse it directly
  return (
    process.env.NEXT_PUBLIC_API_URL ??
    process.env.NEXT_PUBLIC_BACKEND_URL ??
    "http://localhost:3000/api"
  );
}

export async function sendContact(payload: ContactPayload): Promise<{
  ok: boolean;
  via: "backend" | "mailto";
  error?: string;
}> {
  try {
    const res = await fetch(`${getApiBase()}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const body = await res.text().catch(() => "");
      return { ok: false, via: "backend", error: body || `HTTP ${res.status}` };
    }

    return { ok: true, via: "backend" };
  } catch (e) {
    // Si el backend no está disponible, fallback a mailto
    if (typeof window !== "undefined") {
      const lines = [
        `Tipo: ${SUBJECT_LABEL[payload.subject]}`,
        `Nombre: ${payload.name}`,
        `Email: ${payload.email}`,
        payload.phone ? `Teléfono: ${payload.phone}` : "",
        payload.company ? `Empresa / Restaurante: ${payload.company}` : "",
        payload.locations ? `Número de locales: ${payload.locations}` : "",
        payload.message ? `\nMensaje:\n${payload.message}` : "",
      ]
        .filter(Boolean)
        .join("\n");

      const subject = encodeURIComponent(SUBJECT_LABEL[payload.subject]);
      const body = encodeURIComponent(lines);
      window.location.href = `mailto:${CONTACT_TO}?subject=${subject}&body=${body}`;
    }
    return {
      ok: false,
      via: "mailto",
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
